var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepsActive03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12,
    fill: "#6258E3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#6258E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0146 11.3027C17.0146 11.9362 16.8301 12.4648 16.4609 12.8887C16.0918 13.3079 15.5723 13.5905 14.9023 13.7363V13.791C15.7044 13.8913 16.306 14.1419 16.707 14.543C17.1081 14.9395 17.3086 15.4681 17.3086 16.1289C17.3086 17.0905 16.9691 17.8333 16.29 18.3574C15.611 18.877 14.6449 19.1367 13.3916 19.1367C12.2842 19.1367 11.3499 18.9567 10.5889 18.5967V17.168C11.0127 17.3776 11.4616 17.5394 11.9355 17.6533C12.4095 17.7673 12.8652 17.8242 13.3027 17.8242C14.0775 17.8242 14.6562 17.6807 15.0391 17.3936C15.4219 17.1064 15.6133 16.6621 15.6133 16.0605C15.6133 15.5273 15.4014 15.1354 14.9775 14.8848C14.5537 14.6341 13.8883 14.5088 12.9814 14.5088H12.1133V13.2031H12.9951C14.5902 13.2031 15.3877 12.6517 15.3877 11.5488C15.3877 11.1204 15.2487 10.79 14.9707 10.5576C14.6927 10.3252 14.2826 10.209 13.7402 10.209C13.362 10.209 12.9974 10.2637 12.6465 10.373C12.2956 10.4779 11.8809 10.6852 11.4023 10.9951L10.6162 9.87402C11.5322 9.19954 12.5964 8.8623 13.8086 8.8623C14.8158 8.8623 15.6019 9.07878 16.167 9.51172C16.7321 9.94466 17.0146 10.5417 17.0146 11.3027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsActive03);
export default __webpack_public_path__ + "static/media/StepsActive03.fe0a2d2846d418611b52d28d1c448531.svg";
export { ForwardRef as ReactComponent };